
import headerInit from './header';
import scrollingInit from './productScrolling';

jQuery(function() {
  var $ = jQuery;

  $(window).on('beforeunload', function() { $(window).scrollTop(0); });

  headerInit($)

  scrollingInit()

});
